import React from "react";
import * as Collapsible from "@radix-ui/react-collapsible";
import { ChevronDown } from "lucide-react";
import { cn } from "util/cn";

interface DetailPanelProps {
    title?: string;
    children: React.ReactNode;
    className?: string;
    defaultOpen?: boolean;
    headingContent?: React.ReactNode;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
}

const DetailPanel: React.FC<DetailPanelProps> = ({ 
    title, 
    children, 
    className,
    defaultOpen = false,
    headingContent,
    open,
    onOpenChange
}) => {
    // Use controlled or uncontrolled component based on whether open state is provided
    const isControlled = open !== undefined && onOpenChange !== undefined;
    
    return (
        <Collapsible.Root 
            defaultOpen={defaultOpen} 
            open={isControlled ? open : undefined}
            onOpenChange={isControlled ? onOpenChange : undefined}
            className={cn("w-full rounded-lg", className)}
        >
            <Collapsible.Trigger className="group flex flex-col w-full p-2 text-sm text-eoe-text dark:text-eoe-dark-text hover:bg-eoe-icon-hover dark:hover:bg-eoe-dark-icon-hover rounded-lg transition-colors">
                <div className="flex flex-row gap-2 group w-full items-center justify-between">
                    {title && (
                        <span className="font-semibold">{title}</span>
                    )}
                    <ChevronDown 
                        className="h-4 w-4 shrink-0 text-eoe-text-sub dark:text-eoe-dark-text-sub transition-transform duration-200 group-data-[state=open]:rotate-180" 
                    />
                </div>
                {headingContent && (
                    headingContent
                )}
            </Collapsible.Trigger>
            <Collapsible.Content className="overflow-hidden data-[state=closed]:animate-collapse data-[state=open]:animate-expand">
                <div className="p-2">
                    {children}
                </div>
            </Collapsible.Content>
        </Collapsible.Root>
    );
};

export default DetailPanel;
